import { render, staticRenderFns } from "./VitrineTemplate.vue?vue&type=template&id=d5dda112&"
import script from "./VitrineTemplate.vue?vue&type=script&lang=js&"
export * from "./VitrineTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports